/*
 * File: /src/stores/shopify-bar.js
 * Project: air-fields-shopify-frontend
 * -
 * File Created: Thursday, 2nd August 2018 5:16:42 pm
 * Last Modified: Wed Jun 05 2019
 * Last Modified by: Bart
 * -
 * @author: Bart
 *
 * Migrated to App Bridge web components - removed imperative TitleBar/Button APIs
 */
import { logger } from '@/helpers'

const initialState = () => ({
    init: null,
    ready: null,
    scope: null,
    // New properties for web component approach
    pageTitle: 'Dashboard',
    buttonsSet: null,
    visible: false
})

const state = () => initialState()

const actions = {
    INIT({ state, commit }) {
        logger('dispatch init shopify bar start')

        if (state.init) {
            return
        }

        commit('SET_INIT', { init: true })

        // Wait for window.shopify to be available before setting ready
        const checkShopify = setInterval(() => {
            if (window.shopify) {
                clearInterval(checkShopify)
                commit('SET_READY', { ready: true })
                logger('dispatch init shopify bar end - window.shopify is ready')
            }
        }, 100)

        // Timeout after 10 seconds if window.shopify never loads
        setTimeout(() => {
            clearInterval(checkShopify)
            if (!state.ready) {
                logger('WARNING: window.shopify did not load within 10 seconds')
                commit('SET_READY', { ready: true }) // Set ready anyway to prevent blocking
            }
        }, 10000)
    }
}

const mutations = {
    SET_INIT(state, { init }) {
        state.init = init
    },

    SET_READY(state, { ready }) {
        state.ready = ready
    },

    UPDATE_PAGE_CONFIG(state, { title, buttonsSet, visible = true }) {
        state.pageTitle = title || 'Dashboard'
        state.buttonsSet = buttonsSet
        state.visible = visible
    },

    SET_VISIBLE(state, { visible }) {
        state.visible = visible
    }
}

const getters = {
    init: state => state.init,
    ready: state => state.ready,
    pageTitle: state => state.pageTitle,
    buttonsSet: state => state.buttonsSet,
    visible: state => state.visible
}

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
}



// WEBPACK FOOTER //
// ./src/stores/shopify-bar.js